/* eslint-disable */
import React, { useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { useTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { connect } from "react-redux";
import { FormControl, FormLabel, Textarea } from "@chakra-ui/react";
import { edit_Properties } from "../../../../utils/store/actions/users.actions";

function GdprTemplateConfiguration({
  properties,
  edit_Properties,
}: {
  properties: { key: string; value: string }[];
  edit_Properties: (params: { key: string; value: string }) => void;
}) {
  const { t } = useTranslation();
  const [gdprConsentFr, setGdprConsentFr] = useState(
    properties?.find((prop) => prop.key === "GDPR_CONSENT_FR")
  );
  const [gdprConsentEn, setGdprConsentEn] = useState(
    properties?.find((prop) => prop.key === "GDPR_CONSENT_EN")
  );
  const [gdprConsentIt, setGdprConsentIt] = useState(
    properties?.find((prop) => prop.key === "GDPR_CONSENT_IT")
  );
  const [gdprConsentEs, setGdprConsentEs] = useState(
    properties?.find((prop) => prop.key === "GDPR_CONSENT_ES")
  );

  React.useEffect(() => {
    setGdprConsentFr(properties?.find((prop) => prop.key === 'GDPR_CONSENT_FR'))
    setGdprConsentEn(properties?.find((prop) => prop.key === 'GDPR_CONSENT_EN'))
    setGdprConsentIt(properties?.find((prop) => prop.key === 'GDPR_CONSENT_IT'))
    setGdprConsentEs(properties?.find((prop) => prop.key === 'GDPR_CONSENT_ES'))
  }, [properties])

  function handleChangeProperty(e: any, prop: any) {
    edit_Properties({
      key: prop.key,
      value: e.target.value,
    });
  }

  return (
    <Accordion style={{ borderRadius: "10px",
    boxShadow: "none"}}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#AE0064" }} />}
        aria-controls="panel2a-content"
        id="gdprConsent"
      >
        <Typography >{t("GDPR_CONSENT")}</Typography>
      </AccordionSummary>
          <GdrpTextArea
            gdprConsent={gdprConsentFr}
            setGdprConsent={setGdprConsentFr}
            handleChangeProperty={handleChangeProperty}
          />
          <GdrpTextArea
            gdprConsent={gdprConsentEn}
            setGdprConsent={setGdprConsentEn}
            handleChangeProperty={handleChangeProperty}
          />
          <GdrpTextArea
            gdprConsent={gdprConsentIt}
            setGdprConsent={setGdprConsentIt}
            handleChangeProperty={handleChangeProperty}
          />
          <GdrpTextArea
            gdprConsent={gdprConsentEs}
            setGdprConsent={setGdprConsentEs}
            handleChangeProperty={handleChangeProperty}
          />
    </Accordion>
  );
}

function GdrpTextArea({
  gdprConsent,
  setGdprConsent,
  handleChangeProperty,
}: {
  gdprConsent: { key: string; value: string } | undefined;
  setGdprConsent: (val: { key: string; value: string }) => void;
  handleChangeProperty: (e: any, prop: any) => void;
}) {
  const { t } = useTranslation();

  return (
    <AccordionDetails>
    <FormControl id="gdprConsentFr" style={{margin: 5}}>
      <FormLabel>{gdprConsent && t(gdprConsent.key)}</FormLabel>
      <Textarea
        style={{ height: 200 }}
        bg="white"
        value={gdprConsent?.value}
        onChange={(e: any) => {
          gdprConsent && setGdprConsent({ key: gdprConsent.key, value: e.target.value ?? "" });
        }}
        onBlur={(e: any) => {
          handleChangeProperty(e, gdprConsent);
        }}
      />
      </FormControl>
      </AccordionDetails>
  );
}

const mapStateToProps = (state: any) => ({
  properties: state.Users.get_properties,
});

const mapDispatchToProps = {
  edit_Properties,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GdprTemplateConfiguration);
